import React from 'react';

import { Button } from '@unimed-fesp/components';

const ModalFooter = ({
  onCloseModal,
  handleAdicionarModal,
  isDisabledBtnAdicionar,
}) => {
  return (
    <>
      <Button
        tipo="secondary"
        onClick={(e) => onCloseModal(e)}
        justifyCenter
        alignCenter
        type="button"
        marginRight={10}
        font="16px unimed_slabregular"
        width={100}
      >
        cancelar
      </Button>
      <Button
        tipo="primary"
        justifyCenter
        alignCenter
        type="button"
        onClick={(e) => {
          handleAdicionarModal();
          onCloseModal(e);
        }}
        font="16px unimed_slabregular"
        width={100}
        disabled={isDisabledBtnAdicionar}
      >
        adicionar
      </Button>
    </>
  );
};

export default ModalFooter;
